document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initCantidad();
  initFaq();
  initContadores();
  initAnadirRapido();
  initResenasVerMas();
  initCuentaAtras();
  initCarritoVisible();
  initCuestionario();
});

function initReveal() {
  var els = document.querySelectorAll('.of-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('of-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('of-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-of-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-of-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-of-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-of-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-menos]');
    var mas = wrap.querySelector('[data-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-of-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-of-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var precioActual = form.querySelector('[data-of-precio-actual]');
    var precioAnterior = form.querySelector('[data-of-precio-anterior]');
    var ahorro = form.querySelector('[data-of-ahorro]');
    var boton = form.querySelector('[data-of-boton-comprar]');
    var disponibilidad = form.querySelector('[data-of-disponibilidad]');
    var grupos = form.querySelectorAll('[data-of-opcion]');

    if (!grupos.length) return; // variante única: ya viene renderizada del servidor, nada que sincronizar

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function seleccionActual() {
      var valores = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-activo');
        valores.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return valores;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) {
        if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-texto-no-disponible') || 'No disponible'; }
        return;
      }
      idInput.value = variante.id;
      if (precioActual) precioActual.textContent = moneda(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = moneda(variante.compare_at_price);
          precioAnterior.style.display = '';
          if (ahorro) {
            var pct = Math.round((1 - variante.price / variante.compare_at_price) * 100);
            ahorro.textContent = (ahorro.getAttribute('data-prefijo') || 'Ahorra') + ' ' + pct + '%';
            ahorro.style.display = '';
          }
        } else {
          precioAnterior.style.display = 'none';
          if (ahorro) ahorro.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        boton.textContent = variante.available
          ? (boton.getAttribute('data-texto-disponible') || 'Añadir al carrito')
          : (boton.getAttribute('data-texto-agotado') || 'Agotado');
      }
      if (disponibilidad) {
        disponibilidad.classList.toggle('agotado', !variante.available);
        disponibilidad.textContent = variante.available
          ? (disponibilidad.getAttribute('data-texto-disponible') || 'En stock, listo para enviar')
          : (disponibilidad.getAttribute('data-texto-agotado') || 'Agotado por ahora');
      }
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-activo'); });
          btn.classList.add('is-activo');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initFaq() {
  document.querySelectorAll('[data-of-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-of-faq-pregunta]');
    var respuesta = item.querySelector('[data-of-faq-respuesta]');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('is-abierto');
      item.closest('[data-of-faq-lista]').querySelectorAll('[data-of-faq-item]').forEach(function (otro) {
        otro.classList.remove('is-abierto');
        otro.querySelector('[data-of-faq-respuesta]').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('is-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-of-contador]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseInt(el.getAttribute('data-of-contador'), 10) || 0;
    var sufijo = el.getAttribute('data-sufijo') || '';
    var duracion = 1200;
    var inicio = null;
    function paso(ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min(1, (ts - inicio) / duracion);
      el.textContent = Math.round(progreso * fin) + sufijo;
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.textContent = el.getAttribute('data-of-contador') + (el.getAttribute('data-sufijo') || ''); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animar(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initAnadirRapido() {
  document.addEventListener('click', function (evt) {
    var boton = evt.target.closest('[data-of-anadir-rapido]');
    if (!boton || boton.disabled) return;
    evt.preventDefault();

    var variantId = boton.getAttribute('data-variant-id');
    if (!variantId) return;

    var span = boton.querySelector('span');
    var textoOriginal = span ? span.textContent : boton.textContent;
    boton.disabled = true;
    if (span) span.textContent = 'Añadiendo…';

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    var sections = cart && cart.getSectionsToRender
      ? cart.getSectionsToRender().map(function (s) { return s.section || s.id; })
      : [];

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          boton.disabled = false;
          if (span) span.textContent = textoOriginal;
          return;
        }
        if (cart && cart.renderContents) {
          cart.renderContents(response);
        } else {
          window.location.reload();
          return;
        }
        if (span) span.textContent = 'Añadido ✓';
        setTimeout(function () {
          boton.disabled = false;
          if (span) span.textContent = textoOriginal;
        }, 1200);
      })
      .catch(function () {
        window.location.reload();
      });
  });
}

function initResenasVerMas() {
  document.querySelectorAll('[data-of-resenas]').forEach(function (grid) {
    var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('[data-of-resena]'));
    var total = tarjetas.length;
    var inicial = parseInt(grid.getAttribute('data-mostrar-inicial'), 10) || total;
    var incremento = parseInt(grid.getAttribute('data-incremento'), 10) || total;
    var wrap = grid.parentElement.querySelector('[data-of-resenas-botones]');
    var botonMas = wrap ? wrap.querySelector('[data-of-resenas-boton="mas"]') : null;
    var botonMenos = wrap ? wrap.querySelector('[data-of-resenas-boton="menos"]') : null;
    var visibles = inicial;

    function actualizar() {
      tarjetas.forEach(function (tarjeta, i) {
        if (i < visibles) {
          tarjeta.removeAttribute('data-of-resena-oculta');
        } else {
          tarjeta.setAttribute('data-of-resena-oculta', '');
        }
      });
      if (botonMas) botonMas.hidden = visibles >= total;
      if (botonMenos) botonMenos.hidden = visibles <= inicial;
    }

    if (botonMas) {
      botonMas.addEventListener('click', function () {
        visibles = Math.min(total, visibles + incremento);
        actualizar();
      });
    }
    if (botonMenos) {
      botonMenos.addEventListener('click', function () {
        visibles = inicial;
        actualizar();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    actualizar();
  });
}

function initCuentaAtras() {
  document.querySelectorAll('[data-of-cuenta-atras]').forEach(function (reloj) {
    var h = reloj.querySelector('[data-unidad="h"]');
    var m = reloj.querySelector('[data-unidad="m"]');
    var s = reloj.querySelector('[data-unidad="s"]');

    function proximaMedianoche() {
      var ahora = new Date();
      var fin = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1, 0, 0, 0, 0);
      return fin;
    }

    var objetivo = proximaMedianoche();

    function dosDigitos(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var restante = objetivo - new Date();
      if (restante <= 0) {
        objetivo = proximaMedianoche();
        restante = objetivo - new Date();
      }
      var horas = Math.floor(restante / 3600000);
      var minutos = Math.floor((restante % 3600000) / 60000);
      var segundos = Math.floor((restante % 60000) / 1000);
      if (h) h.textContent = dosDigitos(horas);
      if (m) m.textContent = dosDigitos(minutos);
      if (s) s.textContent = dosDigitos(segundos);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initCarritoVisible() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  var forzar = function () {
    if (drawer.classList.contains('active')) {
      drawer.style.setProperty('visibility', 'visible', 'important');
    } else {
      drawer.style.removeProperty('visibility');
    }
  };
  forzar();
  new MutationObserver(forzar).observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

function initCuestionario() {
  document.querySelectorAll('[data-of-quiz]').forEach(function (quiz) {
    var pasos = quiz.querySelectorAll('[data-of-quiz-paso]');
    var barra = quiz.querySelector('[data-of-quiz-progreso]');
    var resultados = quiz.querySelectorAll('[data-of-quiz-resultado-item]');
    var reiniciar = quiz.querySelector('[data-of-quiz-reiniciar]');
    var totalPreguntas = 4;
    var respuestaCategoria = null;

    function irAPaso(idPaso) {
      pasos.forEach(function (paso) {
        paso.classList.toggle('is-activo', paso.getAttribute('data-of-quiz-paso') === idPaso);
      });
      if (barra) {
        var progreso = idPaso === 'resultado' ? 100 : (parseInt(idPaso, 10) + 1) / totalPreguntas * 100;
        barra.style.width = progreso + '%';
      }
    }

    quiz.querySelectorAll('[data-of-quiz-opcion]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var pregunta = boton.getAttribute('data-pregunta');
        var valor = boton.getAttribute('data-valor');
        if (pregunta === '0') respuestaCategoria = valor;

        var siguiente = String(parseInt(pregunta, 10) + 1);
        if (parseInt(pregunta, 10) < totalPreguntas - 1) {
          irAPaso(siguiente);
        } else {
          resultados.forEach(function (item) {
            item.hidden = item.getAttribute('data-valor') !== respuestaCategoria;
          });
          irAPaso('resultado');
        }
      });
    });

    if (reiniciar) {
      reiniciar.addEventListener('click', function () {
        respuestaCategoria = null;
        resultados.forEach(function (item) { item.hidden = true; });
        irAPaso('0');
      });
    }
  });
}
